import { Navigate, useLocation } from 'react-router-dom';
import { getCustomerSession } from '../../lib/customerSession';

/**
 * Around the client's screens: a visitor with no session signs in first.
 * Places, `maps/config` and routes all answer only a client's token, so a
 * signed-out visitor got a blank map and an empty search (2 Oct 2026).
 * Modelled on `DriverAuthGate`.
 */
export default function CustomerAuthGate({ children }) {
  const location = useLocation();
  if (!getCustomerSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
